module.exports = __webpack_public_path__ + "static/media/whatsappCTA.5726d84b.svg";